import { render, staticRenderFns } from "./ManagementNewsPage.vue?vue&type=template&id=635b87c4"
import script from "./ManagementNewsPage.vue?vue&type=script&lang=js"
export * from "./ManagementNewsPage.vue?vue&type=script&lang=js"
import style0 from "./ManagementNewsPage.vue?vue&type=style&index=0&id=635b87c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports